module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAbFBMVEUAAABYlPw7gPw7gfw8gPxYlPw7gPxZlPxYk/xZk/xYlPxYlPtsof9ZlPw7gPtZlf1ZlfxZl/9gmP9ol/88gPxZk/tYlPtZlPtZlPxalP1Zlvxblftalftbl/9clv9gl/9Yk/w7gPxHiPtPjfsGfZ8gAAAAIHRSTlMA+/nz/Pb28/jv44cGm4V+TTMQC+/a1tKkZlxGQTsnIMx677UAAACMSURBVCjPncvrDsIgDIZh6M6bbrp5PpZx//cofpLMUEiM7w8S+rTqh6ZhE53f98ynUYxXnWZXGx5tD+xbj3LdWhxdl/Ujo9n6o+mzPmgOam9v6DjSw8HzPIsuChnjnp1Rrob9f4EsB+gEVBGgBJSAopZQAgoBBKgjkAEqATlAJ6H5BjJB5KEPhHr1Ty/+7hghQL07iAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gaoxiao_small.png
// module id = R7Ql
// module chunks = 36